<template>
    <transition name="fade">
      <div v-if="visible" class="fixed" @click.stop>
        <div class="bg-white popup">
          <div class="popup-header">
            <h1 class="title">Cambiar plan de códigos personalizados</h1>
            <img src="@/assets/images/ic_close.svg" class="close_icon" @click="closePopup(true)" />
          </div>
          <div class="popup-body">
            <div class="fields">
              <span>Indica el plan origen del que quieres cambiar los códigos:</span>
              <input type="number" placeholder="Plan" v-model="originPlanId" />
              <span class="selected-plan-info" v-if="originPlanIdInfo">Plan seleccionado: {{ originPlanIdInfo.promo_title }}</span>
              <span class="selected-plan-info" style="margin-top: 0px;" v-if="originPlanIdInfo">Stock actual: {{ originPlanIdInfo.stock }}</span>
              <span style="margin-top: 30px;" v-if="originPlanIdInfo">Indica cuántos códigos del plan quieres cambiar:</span>
              <input v-if="originPlanIdInfo" type="number" placeholder="Cantidad" v-model="originCodesCount" />
            </div>
          </div>
          <div class="popup-footer">
            <button @click="closePopup(true)" class="secondary_button">Cancelar</button>
            <button @click="saveClicked()" class="main_button">Guardar</button>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, watch, defineEmits, defineProps } from 'vue';
  import { useLoadingStore } from "@/stores/loadingStore";
  import { refreshToken } from "@/services/authService";
  import { useRouter } from 'vue-router';

  const props = defineProps({
    planId: Number
  });
  
  const loadingStore = useLoadingStore();
  const router = useRouter();

  const visible = ref(false);
  const originPlanId = ref(0);
  const originPlanIdInfo = ref(0);
  const originCodesCount = ref(0);
  const cinemaPromoStocks = ref([]);

  const emit = defineEmits(['changePlanOfCustomCodesSaved', 'changePlanOfCustomCodesErrorHappened', 'changePlanOfCustomCodesPopupCancelled']);

  watch(() => props.planId, (newVal) => {
    visible.value = newVal > 0;
    if (visible.value) {
      getCinemaPlansStock();
    }
  });
    
  watch(() => originPlanId.value, (newVal) => {
    if (newVal) {
      originPlanIdInfo.value = cinemaPromoStocks.value.find(promo => promo.promo_id === newVal);
    } else {
      originPlanIdInfo.value = null
    }
  });
  const closePopup = (emitEvent) => {
    visible.value = false;
    originPlanId.value = 0;
    originCodesCount.value = 0;
    if (emitEvent) {
      emit('changePlanOfCustomCodesPopupCancelled');
    }
  };

  const getCinemaPlansStock = async () => {
    loadingStore.setLoading(true);

    try {
      let response = await callAPIToGetCinemaPlansStock();

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await callAPIToGetCinemaPlansStock();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        loadingStore.setLoading(false);
        emit('changePlanOfCustomCodesErrorHappened', 'Se ha producido un error obteniendo la información necesaria para poder cambiar de plan los códigos personalizados.');
        return;
      }

      const data = await response.json();

      if (data.errors) {
        loadingStore.setLoading(false);
        emit('changePlanOfCustomCodesErrorHappened', data.message);
        closePopup(true);
      } else {
        loadingStore.setLoading(false);
        cinemaPromoStocks.value = data.datos;
      }
    } catch (exception) {
      loadingStore.setLoading(false);
      emit('changePlanOfCustomCodesErrorHappened', exception.message);
      closePopup(true);
    }
  }

  async function callAPIToGetCinemaPlansStock(){
    return await fetch(process.env.VUE_APP_API_URL+"api/god/plans/get_cinema_promos_stock?user_id="+localStorage.getItem('user_id'), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "vgod": process.env.VUE_APP_API_VGOD,
        "cp-token": process.env.VUE_APP_API_CP_TOKEN,
        "Authorization": "Bearer " + localStorage.getItem('token')
      },
    });
  }

  const saveClicked = async () => {
    loadingStore.setLoading(true);

    if (originPlanId.value <= 10000) {
      loadingStore.setLoading(false);
      emit('changePlanOfCustomCodesErrorHappened', 'Indica el plan origen de los códigos.');
      return;
    }

    if (originCodesCount.value <= 0 || originCodesCount.value > originPlanIdInfo.value.stock) {
      loadingStore.setLoading(false);
      emit('changePlanOfCustomCodesErrorHappened', 'Indica la cantidad de códigos a cambiar, debe ser un valor entre 1 y ' + originPlanIdInfo.value.stock + '.');
      return;
    }

    try {
      let response = await callAPIToChangePlanOfCustomCodes();

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await callAPIToChangePlanOfCustomCodes();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        loadingStore.setLoading(false);
        emit('changePlanOfCustomCodesErrorHappened', 'Se ha producido un error obteniendo la información necesaria para poder cambiar de plan los códigos personalizados.');
        return;
      }

      const data = await response.json();

      if (data.errors) {
        loadingStore.setLoading(false);
        emit('changePlanOfCustomCodesErrorHappened', data.message);
        closePopup(true);
      } else {
        loadingStore.setLoading(false);
        emit('changePlanOfCustomCodesSaved', originCodesCount.value);
        closePopup(false);
      }
    } catch (exception) {
      loadingStore.setLoading(false);
      emit('changePlanOfCustomCodesErrorHappened', exception.message);
      closePopup(true);
    }
  }
  
  async function callAPIToChangePlanOfCustomCodes(){
    return await fetch(process.env.VUE_APP_API_URL+"api/god/plans/change_cinema_promo_codes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "vgod": process.env.VUE_APP_API_VGOD,
        "cp-token": process.env.VUE_APP_API_CP_TOKEN,
        "Authorization": "Bearer " + localStorage.getItem('token')
      },
      body: JSON.stringify({
        "user_id": localStorage.getItem('user_id'),
        "origin_plan_id": originPlanId.value,
        "destination_plan_id": props.planId,
        "codes_count": originCodesCount.value 
      }),
    });
  }

  </script>
  
  <style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  .fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  
  .bg-white {
    background-color: white;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-lg);
    width: 100%;
    max-width: 600px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .popup-header {
    padding: var(--spacing-md) var(--spacing-lg);
    border-bottom: 1px solid var(--light-gray);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    color: var(--text-color-dark);
    margin: 0;
  }

  .close_icon {
    position: absolute;
    right: var(--spacing-md);
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    cursor: pointer;
    opacity: 0.6;
    transition: opacity var(--transition-fast);
  }

  .close_icon:hover {
    opacity: 1;
  }

  .popup-body {
    padding: var(--spacing-lg);
    overflow-y: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md);
  }

  .fields {
    display: flex;
    flex-direction: column;
  }

  .selected-plan-info {
    margin-top: 30px;
    font-weight: 500;
    font-size: 16px;
    color: var(--text-color-light);

  }

  .fields label{
    margin-top: 0;
    font-weight: 600;
    font-size: 14px;
    color: var(--text-color-dark);
  }

  .fields input, .fields textarea {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    border: 1px solid var(--gray);
    border-radius: var(--radius-md);
    font-family: inherit;
    font-size: 14px;
    transition: border-color var(--transition-fast);
  }

  .fields input:focus, .fields textarea:focus {
    outline: none;
    border-color: var(--primary-color);
  }

  .popup-footer {
    padding: var(--spacing-md) var(--spacing-lg);
    border-top: 1px solid var(--light-gray);
    display: flex;
    justify-content: flex-end;
    gap: var(--spacing-md);
    background-color: var(--white);
  }

  .secondary_button, .main_button {
    width: auto;
    min-width: 120px;
  }
  </style>
  